import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme:any) => ({
    root:{
        width:"70%",
        margin:"0 auto",
        paddingTop:"7%",
        paddingBottom:"20%",
        [theme.breakpoints.down('575')]: {
            width:"90%",   
        },
    },
    imgArea:{
        textAlign:"center",
        marginBottom:"40px",
        "& img":{
            maxWidth:'100%',
            height:'auto'
        }
    },
    title:{
        fontSize:32,
        fontWeight:"bold",
        textAlign:'center',
        paddingBottom:60,
        [theme.breakpoints.down('767')]: {
           fontSize:24  
        },
    },
    subtitle:{
        fontSize:25,
        fontWeight:500,
        textAlign:'center',
        paddingBottom:60,
        [theme.breakpoints.down('767')]: {
            fontSize:20
         },
    },
    icon: {
        margin: "0 10px",
    },
    tryAgainTxt:{
        fontSize:20,
        fontWeight:500,
        textAlign:'center',
        paddingBottom:39,
        "& a":{
            "&:hover":{
                color:"#202020"
            }
        }
    },
    spinnerWrapper:{
        margin:'100px auto 0',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
}))

export default useStyles;